module.exports = __webpack_public_path__ + "assets/img/upload.4bcf6692.svg";